"use client";
import React, { Suspense, useEffect, useMemo } from "react";
import { IconButton } from "@mui/material";
import { Button } from "antd";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import Link from "next/link";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useLocalStorage } from "../detailed-form/utils/hooks";
import Image from "next/image";
import { PATHS_B } from "@/app/get-started-v3/constants";

import imgLogoMain from "@/public/fair-logo.svg";
import imgWebSecure from "@/public/website-secured.svg";
import FeedbackButton from "../feedback-button";

const HeaderInternal = ({ appRouter }) => {
  const { loadFromStorage } = useLocalStorage();

  const pathname = usePathname();
  const params = useSearchParams();

  const ancilaryPathnames = [
    // "/terms-and-conditions",
    // "/privacy-policy",
    // "/complaints",
    // "/faqs",
  ];

  const handleOnNavClick = () => {
    // If user came from express router on faqs and now going back, so we need to route them back to where the left
    if (params.get("referrer") === "express" && pathname === "/faqs") {
      const currentId = loadFromStorage("currentId");
      currentId
        ? appRouter.push(`/claim?id=${currentId}`)
        : appRouter.push(`/claim`);
    } else if (params.get("referrer") === "my-claims" && pathname === "/faqs") {
      appRouter.push(`/my-claims`);
    } else if (ancilaryPathnames.includes(pathname)) {
      appRouter.back();
    } else if (pathname === "/my-claims") {
      const currentId = loadFromStorage("currentId");
      currentId
        ? appRouter.push(`/claim?id=${currentId}`)
        : appRouter.push(`/claim`);
    } else if (pathname === "/") {
      const currentId = loadFromStorage("currentId");
      appRouter.push(`/claim${currentId ? "?id=" + currentId : ""}`);
    } else {
      appRouter.push(`/my-claims`);
    }
  };

  return (
    <>
      {[...ancilaryPathnames, "/my-claim"].includes(pathname) ? (
        <IconButton
          onClick={() => {
            handleOnNavClick();
          }}
        >
          <KeyboardBackspaceIcon
            style={{
              fontSize: "2rem",
              color: "#fff",
            }}
          />
        </IconButton>
      ) : null}
    </>
  );
};

const HeaderContainer = ({ showFeedbackButton }) => {
  const appRouter = useRouter();

  const linksComp = useMemo(
    () => (
      <>
        <Link href="/how-it-works" className="link-unset showOnlyOnMoreThan375">
          How it Works
        </Link>
        <div className="block md:hidden">
          <FeedbackButton mini />
        </div>
      </>
    ),
    []
  );

  // useEffect(() => {
  //   appRouter.prefetch("/how-it-works");
  //   appRouter.prefetch(PATHS_B.CLAIM);
  //   appRouter.prefetch("/claim");
  //   appRouter.prefetch("/my-claims");
  // }, []);

  return (
    <div
      className="sticky top-0 bg-white py-3 w-full flex justify-center items-center"
      style={{ zIndex: 1100 }}
    >
      <div className="flex items-center w-full">
        <div className="container flex justify-between items-center w-full">
          <Link href="/">
            <Image src={imgLogoMain} alt="logo" width={110} height={40} />
          </Link>
          <div className="w-full flex justify-end items-center">
            <div className="justify-center items-center gap-3 md:gap-5 font-semibold flex">
              {!showFeedbackButton && (
                <div className="hidden md:flex justify-center items-center gap-3 md:gap-5 font-semibold">
                  {linksComp}
                </div>
              )}
              {showFeedbackButton && linksComp}
              {!showFeedbackButton && (
                <div className="hidden md:block">
                  <Button
                    type="primary"
                    className="px-4 py-4 pulsating-btn"
                    style={{
                      borderRadius: "12px",
                      fontSize: "18px",
                    }}
                    onClick={() => {
                      appRouter.push(PATHS_B.CLAIM);
                    }}
                  >
                    Find Agreements
                  </Button>
                </div>
              )}
            </div>

            {!showFeedbackButton && (
              <Image
                src={imgWebSecure}
                alt="logo"
                width={95}
                height={38}
                className="block lg:hidden"
              />
            )}
          </div>

          <Suspense fallback={<div></div>}>
            <HeaderInternal appRouter={appRouter} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default HeaderContainer;
